import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';

import { AuthService } from 'src/app/shared/services/auth.service';
import { RouteService } from 'src/app/shared/services/route.service';


export interface instructor {
  cantCursos: number;
  cantVentas: number;
  empresaId: string;
  empresaNombre: string;
  fechaCreacion: any;
  id: string;
  usuarioInstructorId: string;
  nombre: string;
  publicado: boolean;
}

@Component({
  selector: 'lista-instructores',
  templateUrl: './lista-instructores.component.html',
  styleUrls: ['./lista-instructores.component.css']
})

export class ListaInstructoresComponent {

  constructor(
    public authService: AuthService,
    public afAuth: AngularFireAuth,
    private afs: AngularFirestore,
    public routeService: RouteService,
  ) { }

  array: instructor[] = [];

  ngOnInit() {
    this.afs.doc("global/indiceInstructores").get().subscribe(snap => {
      const instructores = snap.data();
      let arr = []
      Object.keys(instructores).map(function (key) {
        arr.push(instructores[key])
        return arr;
      });
      const length = arr.length
      let arreglo = []
      for (let index = 0; index < length; index++) {
        const instructor: instructor = {
          cantCursos: arr[index].cantCursos,
          cantVentas: arr[index].cantVentas,
          empresaId: arr[index].empresaId,
          empresaNombre: arr[index].empresaNombre,
          fechaCreacion: arr[index].fechaCreacion,
          publicado: arr[index].publicado,
          id: arr[index].id,
          usuarioInstructorId: arr[index].usuarioInstructorId,
          nombre: arr[index].nombre,
        }
        arreglo.push(instructor)
      }
      this.array = arreglo
      this.array.sort((a, b) => a.nombre.localeCompare(b.nombre));
      console.log(arreglo)
    })
  }

}